/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import { FocusOutline } from '../../mixins/index.js';
import { rem } from '../../utils/functions.js';
import { getArrowAlignment, getTooltipAlignment } from './utils.js';
import { typography } from '../../typography/typography.js';

var Root = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-10dhfm3-0"
})(["display:inline-block;position:relative;line-height:", ";box-sizing:border-box;", ""], rem(20), function (_ref) {
  var rootStyle = _ref.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : undefined;

// display: flex vertically centers the tooltip icon
var ToggleButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__ToggleButton",
  componentId: "sc-10dhfm3-1"
})(["display:flex;width:100%;height:100%;color:", ";font-size:", ";line-height:", ";cursor:", ";border:none;background:none;padding:0px;vertical-align:bottom;.mux-Tooltip-Icon{pointer-events:none;}&:hover{color:", ";text-decoration:none;}&:focus-visible{", ";}", ""], function (_ref2) {
  var showTooltip = _ref2.showTooltip,
    theme = _ref2.theme;
  return showTooltip ? theme.colorPalette.primaryColors.main.shade_dark_2 : theme.colorPalette.primaryColors.main.shade_default;
}, rem(20), rem(20), function (_ref3) {
  var activateOnHover = _ref3.activateOnHover;
  return activateOnHover ? 'help' : 'unset';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.primaryColors.main.shade_dark_2;
}, FocusOutline, function (_ref5) {
  var toggleButtonStyle = _ref5.toggleButtonStyle;
  return toggleButtonStyle;
});
process.env.NODE_ENV !== "production" ? ToggleButton.displayName = 'ToggleButton' : undefined;
var Arrow = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Arrow",
  componentId: "sc-10dhfm3-2"
})(["position:absolute;height:20px;width:20px;z-index:10000;background-color:", ";", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, function (props) {
  return getArrowAlignment(props);
});
process.env.NODE_ENV !== "production" ? Arrow.displayName = 'Arrow' : undefined;
var TooltipWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__TooltipWrapper",
  componentId: "sc-10dhfm3-3"
})(["position:absolute;box-sizing:border-box;user-select:none;width:", "px;z-index:10000;", ""], function (_ref7) {
  var bubbleWidth = _ref7.bubbleWidth;
  return bubbleWidth;
}, function (props) {
  return getTooltipAlignment(props);
});
process.env.NODE_ENV !== "production" ? TooltipWrapper.displayName = 'TooltipWrapper' : undefined;
var TooltipContent = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__TooltipContent",
  componentId: "sc-10dhfm3-4"
})(["position:relative;display:flex;background:", ";color:", ";margin:auto;padding:20px;text-align:left;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
});
process.env.NODE_ENV !== "production" ? TooltipContent.displayName = 'TooltipContent' : undefined;
var TooltipText = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__TooltipText",
  componentId: "sc-10dhfm3-5"
})(["font-family:", ";font-weight:", ";font-size:", ";margin:0px;line-height:", ";max-width:300px;text-align:left;a{color:inherit;}"], typography.fontFamily, typography.fontWeightLight, typography.fontSizeSmall, rem(20));
process.env.NODE_ENV !== "production" ? TooltipText.displayName = 'TooltipText' : undefined;
var CloseButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__CloseButton",
  componentId: "sc-10dhfm3-6"
})(["position:absolute;top:8px;right:11px;background:none;border:none;padding:0;margin:0;cursor:pointer;"]);
process.env.NODE_ENV !== "production" ? CloseButton.displayName = 'CloseButton' : undefined;

export { Arrow, CloseButton, Root, ToggleButton, TooltipContent, TooltipText, TooltipWrapper };
